import { Flex, Text, SelectField, View } from "@aws-amplify/ui-react";
import { SetteiInputBox, CommonDivider } from '../../../ui-components';
import {
  SETTING_ITEM_TYPE_INPUT,
  inputNumberLimit,
  keisokuKanshiSettingJson,
  convertStatusTypeValueToSelectValue,
  convertSelectValueToStatusTypeValue,
} from '../../../lib/SettingUtil';

const Header = () => {
  return (
    <Flex
      gap="48px"
      padding="16px 32px 16px 32px"
      backgroundColor="rgba(245,245,245,1)"
    >
      <Text
        fontFamily="Noto Sans"
        fontSize="16px"
        fontWeight="400"
        color="rgba(53,56,59,1)"
        lineHeight="16px"
        letterSpacing="0.65px"
        width="96px"
        children="対象周波数"
      />
      <Text
        fontFamily="Noto Sans"
        fontSize="16px"
        fontWeight="400"
        color="rgba(53,56,59,1)"
        lineHeight="16px"
        letterSpacing="0.65px"
        width="160px"
        children="監視項目"
      />
      <Text
        fontFamily="Noto Sans"
        fontSize="16px"
        fontWeight="400"
        color="rgba(53,56,59,1)"
        lineHeight="16px"
        letterSpacing="0.65px"
        width="120px"
        children="有効／無効"
      />
      <Text
        fontFamily="Noto Sans"
        fontSize="16px"
        fontWeight="400"
        color="rgba(53,56,59,1)"
        lineHeight="16px"
        letterSpacing="0.65px"
        width="120px"
        children="状態種別"
      />
      <Text
        fontFamily="Noto Sans"
        fontSize="16px"
        fontWeight="400"
        color="rgba(53,56,59,1)"
        lineHeight="16px"
        letterSpacing="0.65px"
        width="190px"
        children="閾値"
      />
      <Text
        fontFamily="Noto Sans"
        fontSize="16px"
        fontWeight="400"
        color="rgba(53,56,59,1)"
        lineHeight="16px"
        letterSpacing="0.65px"
        width="140px"
        children="アラートカウント"
      />
    </Flex>
  )
}

const Row = ({
  slot,
  threshold,
  opt,
  setting,
  editSettingJson,
  setEditSettingJson,
}) => {

  return (
    <Flex >
      <Text
        paddingTop="20px"
        fontFamily="Noto Sans"
        fontSize="14px"
        fontWeight="700"
        color="rgba(53,56,59,1)"
        lineHeight="22.399999618530273px"
        textAlign="left"
        letterSpacing="0.55px"
        width="190px"
        children={opt.labeltext}
      />

      <Flex >
        {/* 有効・無効 */}
        <View paddingTop="20px" width="150px" height="87px" >
          <SelectField
            width="120px"
            size="small"
            fontSize="0.875rem"
            gap={"0.25rem"}
            options={["ON", "OFF"]}
            value={setting.Monitoring ? "ON" : "OFF"}
            onChange={(e) => {
              const enable = e.target.value === "ON";

              setEditSettingJson({
                ...editSettingJson,
                [slot]: {
                  ...editSettingJson[slot],
                  [threshold]: {
                    ...editSettingJson[slot][threshold],
                    Monitoring: enable,
                  }
                }
              })
            }}
          />
        </View>

        {/* 状態種別 */}
        <View paddingTop="20px" width="150px" height="87px" >
          <SelectField
            top="20px"
            width="120px"
            size="small"
            fontSize="0.875rem"
            gap={"0.25rem"}
            options={["異常", "警告", "情報"]}
            isDisabled={!setting.Monitoring}
            value={convertStatusTypeValueToSelectValue(setting.Status_Type)}
            onChange={(e) => {
              const enable = convertSelectValueToStatusTypeValue(e.target.value);

              setEditSettingJson({
                ...editSettingJson,
                [slot]: {
                  ...editSettingJson[slot],
                  [threshold]: {
                    ...editSettingJson[slot][threshold],
                    Status_Type: enable,
                  }
                }
              })
            }}
          />
        </View>

        {/* 閾値 */}
        <Flex width="225px" direction="row">
          <SetteiInputBox
            attention="true"
            label="true"
            unit={opt.value.unit}
            overrides={{
              "dBm/MHz": {
                children: opt.value.unit,
              },
              PositioningFrame: {
                width: "120px",
              },
              TextField: {
                top: "20px",
                label: opt.label,
                value: setting.Value,
                placeholder: "",
                isDisabled: !setting.Monitoring,
                ...opt.value.input,
                ...opt.value.range && {
                  min: opt.value.range.min,
                  max: opt.value.range.max,
                },
                onChange: (e) => {
                  setEditSettingJson({
                    ...editSettingJson,
                    [slot]: {
                      ...editSettingJson[slot],
                      [threshold]: {
                        ...editSettingJson[slot][threshold],
                        Value: e.target.value,
                      }
                    }
                  });
                },
                onBlur: (e) => {
                  let value = e.target.value;
                  console.log(value);

                  // 数字の場合
                  if (opt.value.type === SETTING_ITEM_TYPE_INPUT) {
                    // 整数の場合
                    value = inputNumberLimit(value, opt.value.input.step, opt.value.range)
                  }
                  console.log(value);

                  setEditSettingJson({
                    ...editSettingJson,
                    [slot]: {
                      ...editSettingJson[slot],
                      [threshold]: {
                        ...editSettingJson[slot][threshold],
                        Value: value,
                      }
                    }
                  });
                },
              },
              Attention: {
                children: opt.value.range != null
                  ? `範囲：${opt.value.range.min}-${opt.value.range.max}`
                  : "",
              },
            }}
          />
        </Flex>

        {/* アラートカウントフラグ */}
        <View paddingTop="20px" width="150px" height="87px" >
          <SelectField
            width="120px"
            size="small"
            fontSize="0.875rem"
            gap={"0.25rem"}
            options={["ON", "OFF"]}
            isDisabled={!setting.Monitoring}
            value={setting.AlertCount_Enable ? "ON" : "OFF"}
            onChange={(e) => {
              const enable = e.target.value === "ON";

              setEditSettingJson({
                ...editSettingJson,
                [slot]: {
                  ...editSettingJson[slot],
                  [threshold]: {
                    ...editSettingJson[slot][threshold],
                    AlertCount_Enable: enable,
                  }
                }
              })
            }}
          />
        </View>

        {/* アラートカウント数 */}
        <Flex width="225px" direction="row">
          <SetteiInputBox
            attention="true"
            label="true"
            unit={opt.alertCount.unit}
            overrides={{
              PositioningFrame: {
                width: "120px",
                // height: "42px",
              },
              TextField: {
                label: opt.alertCount.labeltext,
                value: setting.Alert_Count,
                placeholder: "",
                isDisabled: !setting.Monitoring || !setting.AlertCount_Enable,
                ...opt.alertCount.input,
                ...opt.alertCount.range && {
                  min: opt.alertCount.range.min,
                  max: opt.alertCount.range.max,
                },
                onChange: (e) => {
                  setEditSettingJson({
                    ...editSettingJson,
                    [slot]: {
                      ...editSettingJson[slot],
                      [threshold]: {
                        ...editSettingJson[slot][threshold],
                        Alert_Count: e.target.value,
                      }
                    }
                  });
                },
                onBlur: (e) => {
                  let value = setting.Alert_Count;
                  console.log(value);

                  // 数字の場合
                  value = inputNumberLimit(value, opt.alertCount.input.step, opt.alertCount.range)
                  console.log(value);

                  setEditSettingJson({
                    ...editSettingJson,
                    [slot]: {
                      ...editSettingJson[slot],
                      [threshold]: {
                        ...editSettingJson[slot][threshold],
                        Alert_Count: value,
                      }
                    }
                  });
                },
              },
              Attention: {
                children: opt.alertCount.range != null
                  ? `範囲：${opt.alertCount.range.min}-${opt.alertCount.range.max}`
                  : "",
              },
            }}
          />
        </Flex>
      </Flex>
    </Flex>
  )
}

const SlotRow = ({
  slot,
  slotSetting,
  slotOption,
  editSettingJson,
  setEditSettingJson,
}) => {
  return (
    <Flex direction="column">
      <Flex
        padding="8px 24px 8px 24px"
      >
        <Text
          paddingTop="20px"
          fontFamily="Noto Sans"
          fontSize="14px"
          fontWeight="700"
          color="rgba(53,56,59,1)"
          lineHeight="22.399999618530273px"
          textAlign="left"
          letterSpacing="0.55px"
          width="140px"
          children={slot === "total" ? "合計" : slot}
        />

        <Flex direction="column">
          {
            Object.entries(slotOption).map(([threshold, opt]) => {
              if (!opt || !slotSetting[threshold]) {
                return null;
              }

              const setting = slotSetting[threshold];

              return (
                <Row
                  key={threshold}
                  slot={slot}
                  threshold={threshold}
                  opt={opt}
                  setting={setting}
                  editSettingJson={editSettingJson}
                  setEditSettingJson={setEditSettingJson}
                />
              )
            })
          }
        </Flex>
      </Flex>

      <CommonDivider
        display="flex"
        gap="0"
        direction="row"
        width="unset"
        height="1px"
        justifyContent="center"
        alignItems="center"
        overflow="hidden"
        shrink="0"
        alignSelf="stretch"
      ></CommonDivider>
    </Flex>
  )
}

const InterferenceAlertSetting = ({
  editSettingJson,
  setEditSettingJson,
}) => {

  if (editSettingJson === null) {
    return null;
  }

  return (
    <>
      <Flex direction="column" gap="16px">
        <Text
          fontFamily="Noto Sans"
          fontSize="16px"
          fontWeight="700"
          color="rgba(53,56,59,1)"
          lineHeight="16px"
          letterSpacing="0.65px"
          children="干渉波アラーム監視設定"
        />

        {/*  */}
        <Flex direction="column">
          {/* タイトル */}
          <Header />

          {/* 設定 */}
          {
            // slotの設定
            Object.entries(keisokuKanshiSettingJson).map(([slot, slotOption]) => {
              if (!editSettingJson || !(slot in editSettingJson)) {
                return null;
              }

              // slot設定
              const slotSettingValue = editSettingJson[slot];

              return (
                <SlotRow
                  key={slot}
                  slot={slot}
                  slotSetting={slotSettingValue}
                  slotOption={slotOption}
                  editSettingJson={editSettingJson}
                  setEditSettingJson={setEditSettingJson}
                />
              )
            })
          }
        </Flex>
      </Flex>
    </>
  );
};

export default InterferenceAlertSetting;